import { defineStore } from 'pinia';
import { computed, type ComputedRef } from 'vue';
import { useCartCheckoutStore } from '@white-label-store/cart-checkout';
import { isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled } from '@white-label-plugin/launch-darkly';
import type {
  CartItem,
} from '@white-label-types/parking-checkout';
import { isLoungePass } from '@white-label-helper/is-lounge-pass';

export const useLoungePassStore = defineStore('loungePass', () => {

  const loungePassItem: ComputedRef<CartItem | undefined> = computed(() => {
    const cartCheckoutStore = useCartCheckoutStore();
    const checkoutCartItems = cartCheckoutStore.readCartItems;
    return checkoutCartItems.find((cartItem) => {
      return isLoungePass(cartItem);
    });
  });

  const hasLoungePassItem = computed(() => {
    return Boolean(isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled() && loungePassItem.value);
  });
  const hasAdditionalTravellers = computed(() => {
    return isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled() && loungePassItem.value ? loungePassItem.value.quantity > 1 : false;
  });

  const displayLoungePassAdditionalTravellers = computed(() => {
    return isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled() && hasAdditionalTravellers.value;
  });
  const loungePassTravellersSearchNumber = computed(() => {
      const groups = loungePassItem.value?.search_criteria?.lounges?.groups;

      if (!groups) {
        return 0;
      }

      return Object.values(groups).reduce((sum: number, count: number) => parseInt(sum, 10) + parseInt(count, 10), 0);
  });

  const isLoungePassAdditionalTravellersDetailsRequired = computed(() => {
    if (!loungePassItem.value) return false;
    return loungePassItem.value.inventory_item.additional_fields
    && loungePassItem.value.inventory_item.additional_fields['additional_passengers']
    && loungePassItem.value.inventory_item.additional_fields['additional_passengers'].is_required === true;
  });


  return {
    loungePassItem,
    hasLoungePassItem,
    hasAdditionalTravellers,
    displayLoungePassAdditionalTravellers,
    isLoungePassAdditionalTravellersDetailsRequired,
    loungePassTravellersSearchNumber,
  };
}, {
  persist: true,
});
